module.exports = __webpack_public_path__ + "img/lookup-pwd-plaid.4b5ed9a.svg";